import(/* webpackMode: "eager", webpackExports: ["NotFoundLink"] */ "/codebuild/output/src2425947283/src/apps/web/app/[locale]/NotFoundLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425947283/src/node_modules/@mui/material/Alert/Alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425947283/src/node_modules/@mui/material/AlertTitle/AlertTitle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425947283/src/node_modules/@mui/material/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425947283/src/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425947283/src/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425947283/src/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
